import MobileDetect from "mobile-detect";
import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { useRillContext } from "../rill/RillReact/share/base";

const TooltipPortal = ({
  forOnboarding,
  forNotes,
  children,
  body,
  childrenContainerClass,
  position = "bottom",
  timeOut = 1,
}) => {
  const { locals } = useRillContext();

  // Stable unique ID per instance (React 18)
  const tooltipId = React.useId();

  // Disable tooltips on mobile
  const userAgent = locals?.headers?.["user-agent"] || "";
  const isMobile = React.useMemo(
    () => new MobileDetect(userAgent).mobile(),
    [userAgent]
  );

  // Use position directly with fallback to bottom
  const place = ["top", "bottom", "left", "right"].includes(position)
    ? position
    : "bottom";

  // Build CSS classes for different styles
  let tooltipClassName = "React-Tooltip custom-style z-50";

  if (forNotes) {
    tooltipClassName += " tooltip-notes-style";
  } else if (forOnboarding) {
    tooltipClassName += " tooltip-onboarding-style";
  } else {
    tooltipClassName += " tooltip-default-style";
  }

  return (
    <>
      <span
        className={childrenContainerClass}
        data-tooltip-content={body}
        data-tooltip-id={tooltipId}
        data-tip-disable={isMobile}
        data-tooltip-place={place}
      >
        {children}
      </span>
      <ReactTooltip
        id={tooltipId}
        multiline={true}
        float={true}
        delayShow={timeOut}
        className={tooltipClassName}
        // In `float` mode the tooltip tracks the last known pointer position
        // rather than the anchor, so a scroll with no accompanying pointer
        // move (e.g. click-and-scroll) leaves it stranded on screen. Close it
        // on scroll instead of letting it hang there.
        globalCloseEvents={{ scroll: true }}
      />
    </>
  );
};

export default TooltipPortal;
